import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Input } from '../components/ui/input'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card'
import athleteApi from '../lib/api'

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      await athleteApi.post('/users/forgot-password', {
        email,
        user_type: 'athlete',
      })
      setSuccess(true)
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  if (success) {
    return (
      <div className="flex items-center justify-center min-h-screen relative">
        <div className="fixed inset-0 -z-10 bg-background"></div>

        <div className="w-full max-w-md px-4">
          <Card variant="dark">
            <CardHeader className="text-center">
              <div className="flex justify-center mb-4">
                <img
                  src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
                  alt="Athios Logo"
                  className="w-10 h-10"
                />
              </div>
              <CardTitle className="text-2xl font-bold text-foreground">
                Check Your Email
              </CardTitle>
              <CardDescription className="mt-2 text-gray-600">
                If an account with that email exists, we've sent you a password reset link.
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-gray-700 mb-6">
                Please check your email and click the link to reset your password.
              </p>
              <Link to="/signin" className="text-[#4d7c0f] hover:text-[#a8e45a] font-medium">
                Back to Sign In
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-background"></div>

      <div className="w-full max-w-md px-4">
        <Card variant="dark">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <img
                src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
                alt="Athios Logo"
                className="w-10 h-10"
              />
            </div>
            <CardTitle className="text-2xl font-bold text-foreground">Forgot Password</CardTitle>
            <CardDescription className="mt-2 text-gray-600">
              Enter your email address to receive a password reset link.
            </CardDescription>
          </CardHeader>
          <CardContent>
            {error && <p className="text-red-500 mb-4 text-sm text-center">{error}</p>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-card text-foreground border-foreground/10 focus:border-[#C0FD72] focus:ring-[#C0FD72]/20"
                  required
                />
              </div>
              <Button
                type="submit"
                variant="lime"
                className="w-full font-medium"
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>

            <div className="mt-6 space-y-3 border-t border-foreground/10 pt-4">
              <div className="text-center">
                <p className="text-gray-600 text-sm mb-3">Or</p>
                <Link
                  to="/signin-email"
                  className="text-[#4d7c0f] hover:text-[#a8e45a] font-medium text-sm"
                >
                  Sign in directly via email link
                </Link>
              </div>
            </div>

            <div className="mt-4 text-center">
              <Link
                to="/signin"
                className="text-[#4d7c0f] hover:text-[#a8e45a] font-medium text-sm"
              >
                Back to Sign In
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default ForgotPassword
